module.exports = __webpack_public_path__ + "static/media/listChest.824ec044.png";